import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AutoRedemptionSettingFacade } from '../../facades/auto-redemption-setting/auto-redemption-setting.facade';

@Injectable()
export class AutoRedemptionFormDataGuard {
  constructor(
    private router: Router,
    private autoRedemptionSettingFacade: AutoRedemptionSettingFacade,
  ) {}

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
    const id = next.paramMap.get('id') || next.paramMap.get('programId');
    const routeFragments = next.pathFromRoot
      .map(({ url }) => url.map(({ path }) => path))
      .filter((id) => id.length > 0)
      .reduce((acc, path) => [...acc, ...path], []);

    return this.autoRedemptionSettingFacade.autoRedemptionFormData$.pipe(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      map((data) => data !== null && !!data[id!]),
      tap((state) => {
        if (!state) {
          switch (routeFragments[0]) {
            case 'redeem_cash': {
              const redirectUrl = `${routeFragments[0]}/${routeFragments[1]}`;
              this.router.navigateByUrl(redirectUrl);
              break;
            }
            default: {
              const redirectUrl = `${routeFragments[0]}/${routeFragments[1]}/${routeFragments[3]}`;
              this.router.navigateByUrl(redirectUrl);
              break;
            }
          }
        }
      }),
    );
  }
}
